// extracted by mini-css-extract-plugin
module.exports = {"page":"LC_28","draft":"svTh5","archived":"umWO_","published":"Bjzjm","statusIcon":"TrRwj","priceBookRow":"RP5C4","uploadBtn":"JLKsg","actionRow":"ygYV_","priceBookTable":"xaOs4"};